export const juneAbbreviatedLowercase = "gEFkYc";
export default {juneAbbreviatedLowercase};